import React from "react";
import {
  Grid,
  Table,
  TableHeaderRow,
  TableFilterRow,
  TableEditColumn,
  PagingPanel
} from "@devexpress/dx-react-grid-material-ui";
import {
  FilteringState,
  IntegratedFiltering,
  EditingState,
  PagingState,
  IntegratedPaging,
  SortingState,
  IntegratedSorting
} from "@devexpress/dx-react-grid";
import IconButton from "material-ui/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "material-ui/Dialog";
import Button from "material-ui/Button";
import compose from "lodash/fp/compose";
import { withStateHandlers } from "recompose";

const DataGrid = ({
  columns,
  rows,
  onEdit,
  deleteCustomer,
  open,
  handleOpen,
  handleClose,
  deletingId
}) => (
  <React.Fragment>
    <Grid columns={columns} rows={rows} getRowId={row => row.customerId}>
      <FilteringState defaultFilters={[]} />
      <IntegratedFiltering />
      <SortingState
        defaultSorting={[{ columnName: "name", direction: "asc" }]}
      />
      <IntegratedSorting />
      <PagingState defaultCurrentPage={0} pageSize={10} />
      <IntegratedPaging />
      <EditingState onCommitChanges={x => x} />
      <Table />
      <TableHeaderRow showSortingControls />
      <TableFilterRow />
      <PagingPanel />
      <TableEditColumn
        cellComponent={props => (
          <td>
            <IconButton onClick={() => onEdit(props.tableRow.row.customerId)}>
              <EditIcon />
            </IconButton>
            <IconButton
              onClick={() => handleOpen(props.tableRow.row.customerId)}
            >
              <DeleteIcon />
            </IconButton>
          </td>
        )}
      />
    </Grid>
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Delete Customer?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete this customer? This action is
          irreversible.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          No
        </Button>
        <Button
          onClick={() => {
            deleteCustomer({
              variables: {
                customerId: deletingId
              },
              refetchQueries: ["GetCurrentCustomers"]
            }).then(handleClose);
          }}
          color="primary"
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  </React.Fragment>
);

export default compose(
  withStateHandlers(() => ({ open: false, deletingId: null }), {
    handleClose: () => () => ({ open: false, deletingId: null }),
    handleOpen: () => deletingId => ({ open: true, deletingId })
  })
)(DataGrid);



// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientsDataGrid.js